"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NAMESPACE_SEP = void 0;

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

var NAMESPACE_SEP = '/';
exports.NAMESPACE_SEP = NAMESPACE_SEP;
var counter = {
  models: {},
  actions: {}
};

function modelCount(model, state) {
  if (typeof counter.models[model] === 'undefined') {
    counter.models[model] = 0;
  }

  if (state === true) {
    counter.models[model] += 1;
  } else if (state === false) {
    counter.models[model] = Math.max(counter.models[model] - 1, 0);
  }

  return counter.models[model] > 0;
}

function actionCount(action, state) {
  if (typeof counter.actions[action] === 'undefined') {
    counter.actions[action] = 0;
  }

  if (state === true) {
    counter.actions[action] += 1;
  } else if (state === false) {
    counter.actions[action] = Math.max(counter.actions[action] - 1, 0);
  }

  return counter.actions[action] > 0;
} // reference https://github.com/mobxjs/mobx/blob/master/src/api/actiondecorator.ts


var LoadingStore = (_class = (_temp = function LoadingStore() {
  _classCallCheck(this, LoadingStore);

  _initializerDefineProperty(this, "global", _descriptor, this);

  _initializerDefineProperty(this, "models", _descriptor2, this);

  _initializerDefineProperty(this, "actions", _descriptor3, this);

  _initializerDefineProperty(this, "change", _descriptor4, this);
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "global", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "models", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "actions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "change", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;

    return function (model, action, state) {
      if (action) {
        _this.actions[action] = actionCount(action, state);
      }

      if (state === true) {
        _this.models[model] = modelCount(model, state);
        _this.global = true;
      } else {
        _this.models[model] = Object.keys(_this.actions).filter(function (key) {
          return key && key.startsWith("".concat(model).concat(NAMESPACE_SEP));
        }).some(function (key) {
          return _this.actions[key];
        });
        _this.global = Object.keys(_this.models).some(function (key) {
          return _this.models[key];
        });
      }
    };
  }
})), _class);

var _default = new LoadingStore();

exports.default = _default;